/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  window.addEventListener('theme:variant:change', e => {
    const { target, detail: { variant }} = e

    if (!target.hasAttribute('data-quick-add-modal')) return;
    if (!target.querySelector('.js-email-input')) return;

    target.querySelector('.product-form').classList.remove('has-success')

    target.querySelector('.js-email-input')?.classList[variant.available ? 'add': 'remove']('hidden')
    // target.querySelector('.js-atc-btn')?.classList[variant.available ? 'remove': 'add']('hidden')
    target.querySelector('.js-subscribe-btn')?.classList[variant.available ? 'add': 'remove']('hidden')

    if (variant.available) {
      target.querySelector('.js-email-input').setAttribute('disabled', '')
    } else {
      target.querySelector('.js-email-input').removeAttribute('disabled')
    }
  })

  document.addEventListener('click', e => {
    const button = e.target.closest('.js-subscribe-btn')
    if (!button) return;

    const form = e.target.closest('form')
    const emailInput = form.querySelector('.js-email-input')
    const formData = new FormData(form)
    const id = formData.get('id')
    const email = formData.get('email')

    emailInput.classList.remove('error')

    if (!validateEmail(email)) {
      emailInput.classList.add('error')
      return
    }

    button.classList.add('is-loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: [
            'EMAIL'
          ]
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${id}`
            }
          }
        }
      }
    }

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${ window.theme.settings.klaviyoCompanyId }`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.text())
    .then(() => {
      emailInput.value = ''
      form.classList.add('has-success')
    })
    .catch(err => console.error(err))
    .finally(() => {
      button.classList.remove('is-loading');

      setTimeout(() => {
        form.classList.remove('has-success')
      }, 3000)
    });
  })
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector('#header-menu')
  const accordionItems = mobileMenu.querySelectorAll('.accordion-item')

  accordionItems.forEach(accordionItem => {
    accordionItem.addEventListener('click', e => {
      const hasSubMenu = accordionItem.querySelector('.answer');

      if (!hasSubMenu) {
        return;
      }

      if (e.target.closest('.answer')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      accordionItem.classList.toggle('is-open')
    })
  })
})

const moneyFormat = "${{amount}}"

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "")
  }
  let value = ""
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || moneyFormat

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split(".")
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
    const centsAmount = parts[1] ? decimal + parts[1] : ""

    return dollarsAmount + centsAmount
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".")
      break
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", "")
      break
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",")
      break
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".")
      break
  }

  return formatString.replace(placeholderRegex, value)
}



if (!customElements.get("discount-ninja")) {
  customElements.define("discount-ninja", 	class DiscountNinja extends HTMLElement {
		constructor() {
      super()
      this.init();
  }

  init() {

    document.addEventListener("limoniapps:discountninja:drawercart:refreshed", function (event) { var cart = event.detail.data[0]; 


     });

    function updateCartItem(discountedCart, discountedPrice, finalPrice) {

      const finalPricePercentDiff = ((discountedCart.total.discountedPrice / discountedCart.subtotal.discountedPrice) * 100) - 100
      const finalPricePriceDiff = removeTrailingTwoZeros(formatMoney(discountedCart.subtotal.discountedPrice - discountedCart.total.discountedPrice , theme.moneyFormat))
      const cents = String(parseInt(discountedCart.total.discountedPrice, 10))
      document.querySelectorAll("[data-cart-total][data-final-price]").forEach((el) => {
        el.dataset.cartTotal = cents
      })

      const cartItems = document.querySelector('cart-items')
      cartItems.freeShippingMessageHandle(parseInt(discountedCart.total.discountedPrice))
			cartItems.updateProgress()

      discountedCart.items.forEach(item => {
        const itemElement = document.querySelector(`[data-item="${item.key}"]`);
        const lineOriginalMoney = removeTrailingTwoZeros(formatMoney(item.price.line.original, theme.moneyFormat))
        const lineCompareMoney = removeTrailingTwoZeros(formatMoney(item.price.line.compareAt, theme.moneyFormat))

          const lineDiscountedMoney = removeTrailingTwoZeros(formatMoney(item.price.line.discounted, theme.moneyFormat))
          if(item.discount.line.percentage > 0 || item.price.line.discounted < item.price.line.original || item.price.line.original < item.price.line.compareAt) {

          itemElement?.querySelectorAll('.cart__price')?.forEach(priceElement => {
            priceElement.innerHTML = ` <ins>${item.discount.line.percentage == 100 ? 'Free' : lineDiscountedMoney}</ins><del>${lineCompareMoney ? lineCompareMoney: lineOriginalMoney}</del>`

          })
        } else {
          itemElement?.querySelectorAll('.cart__price')?.forEach(priceElement => {
            priceElement.innerHTML = `<p>${lineOriginalMoney}</p>`
          })
        }

      })
  
      if(Boolean(document.querySelector('.cart__total__discount'))) {
        document.querySelector('.cart__total__discount').remove();
      }
      if(discountedCart.subtotal.discountedPrice !== discountedCart.total.discountedPrice) {
        const discountsWrapper = document.querySelector('[data-cart-discounts]') || document.querySelector('[data-main-cart-discounts]');
        const newDiv = document.createElement('div');
        newDiv.classList.add('cart__total__discount');
        newDiv.innerHTML = `<div class="cart__total">
                  <div><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tags" viewBox="0 0 25 26"><g stroke="#000" stroke-width=".875"><path d="M4.304.79h8.571l12 11.835M9.594 4.17H2.589c-.946 0-1.714.758-1.714 1.692v6.907c0 .449.18.88.502 1.196l10.47 10.329c.67.66 1.755.66 2.423 0 .173-.17.308-.376.394-.602l1.64-4.304 4.364-1.615a1.684 1.684 0 0 0 .61-2.779L10.805 4.666a1.725 1.725 0 0 0-1.211-.495Z"></path><path d="M6.018 8.82a.426.426 0 0 0-.429.423c0 .234.192.423.429.423.236 0 .428-.19.428-.423a.424.424 0 0 0-.426-.422h-.002"></path></g></svg><span>${finalPricePercentDiff}%</span>
                  </div>

                  <span>
                    -${finalPricePriceDiff} </span>
                </div>`;
                discountsWrapper.append(newDiv)
      }

      document.querySelectorAll('[data-final-price]').forEach(item => item.innerHTML = finalPrice);
      document.querySelectorAll('[data-subtotal-price]').forEach(item => item.textContent = discountedPrice);
    }

    // Track the latest DN cart update so a single `theme:cart:customUpdated`
    // listener (registered once, below) can re-apply the discount UI without
    // leaking. Previously, the `theme:cart:customUpdated` listener was
    // registered INSIDE the `la:dn:cart:updated` handler, which added one new
    // global listener per update — every Discount Ninja update would replay
    // all previous updates, causing DOM flicker and unstable totals.
    let latestDnUpdate = null

    if (!document.__clearDnOnCartBeforeBuild) {
      document.__clearDnOnCartBeforeBuild = true
      document.addEventListener("theme:cart:before-build", () => {
        latestDnUpdate = null
      })
    }

    if (!document.__broadcastDnCustomUpdatedBound) {
      document.__broadcastDnCustomUpdatedBound = true
      document.addEventListener("theme:cart:customUpdated", () => {
        if (latestDnUpdate) {
          updateCartItem(latestDnUpdate.discountedCart, latestDnUpdate.discountedPrice, latestDnUpdate.finalPrice)
        }
      })
    }

    document.addEventListener("la:dn:cart:updated", async function(event) {

      const discountedCart = event.detail.data[0]; 
      const isDiscounted = await discountNinja.api.checkout.isDiscounted();
      const discountedPrice = removeTrailingTwoZeros(formatMoney(discountedCart.subtotal.discountedPrice, theme.moneyFormat))
      const finalPrice = removeTrailingTwoZeros(formatMoney(discountedCart.total.discountedPrice, theme.moneyFormat))
      const cartItems = document.querySelector('cart-items');

      latestDnUpdate = { discountedCart, discountedPrice, finalPrice }

      updateCartItem(discountedCart, discountedPrice, finalPrice) 
      cartItems?.updateProgress();

      if (isDiscounted) { 
        
          //  console.log('The cart is discounted', discountedCart, discountNinja.api);
    
          // Add logic when the cart is discounted by Discount Ninja offers
      }
      else {
          // console.log('The cart is not discounted', discountedCart);
          // Add logic when the cart is not discounted by Discount Ninja offers
      }

      document.querySelectorAll('[data-final-price]').forEach(item => item.innerHTML = finalPrice);
      document.querySelectorAll('[data-subtotal-price]').forEach(item => item.textContent = discountedPrice);

    });
    
  }

  })
}

if(window.discountNinja === undefined) {
  document.querySelectorAll('.product-accordion.dn_code').forEach(ele => ele.style.display="none");
}

document.addEventListener('quizKitAddToCartSuccess', function (e) {
  document.querySelector('cart-items')?.getCart();
  document.dispatchEvent(new CustomEvent('theme:product:added', {bubbles: true}));
}, false);

/* ---------------------------------------------------------------------------
 * PDP v2 enhancements. Scoped to the .template-product-pdp-v2 body class so the
 * control PDP is never affected.
 *  1. Accordion: honour the "Open by default" setting (Broadcast's collapsible
 *     component strips the open state on load/resize).
 *  2. Key ingredients: turn the list into a Flickity carousel (arrows + dots).
 *  3. Complete your routine: wire custom arrows to the upsell Flickity instance.
 * ------------------------------------------------------------------------- */
(function () {
  if (!document.body.classList.contains('template-product-pdp-v2')) return;

  function whenFlickity(cb, tries) {
    tries = tries == null ? 30 : tries;
    if (window.themeVendor && window.themeVendor.Flickity) { cb(window.themeVendor.Flickity); return; }
    if (tries <= 0) return;
    requestAnimationFrame(function () { whenFlickity(cb, tries - 1); });
  }

  function openDefaultAccordions() {
    document.querySelectorAll('details[data-default-open]').forEach(function (details) {
      var host = details.closest('collapsible-elements');
      if (host && typeof host.open === 'function') host.open(details);
    });
  }

  var userToggledAccordion = false;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-collapsible-trigger]')) userToggledAccordion = true;
  }, true);

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('collapsible-elements').then(function () {
      requestAnimationFrame(openDefaultAccordions);
    });
  } else {
    requestAnimationFrame(openDefaultAccordions);
  }

  document.addEventListener('theme:resize:width', function () {
    if (userToggledAccordion) return;
    requestAnimationFrame(openDefaultAccordions);
  });

  let kiInstances = [];
  function initKeyIngredients(Flickity) {
    // Drop carousels whose section was swapped out (no-reload PDP swap) so their
    // window resize listeners aren't leaked, then (re)init any un-initialised lists.
    kiInstances = kiInstances.filter(function (f) {
      if (f.element && f.element.isConnected) return true;
      f.destroy();
      return false;
    });
    document.querySelectorAll('.pdp-ki__list').forEach(function (list) {
      if (list.querySelectorAll('.pdp-ki__item').length < 2) return;
      if (Flickity.data(list)) return;
      const kiFlkty = new Flickity(list, {
        cellSelector: '.pdp-ki__item',
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        groupCells: 1,
        pageDots: true,
        prevNextButtons: true,
        adaptiveHeight: false,
        imagesLoaded: true
      });
      // Re-measure once the (lazy) cell images finish loading so Flickity
      // doesn't lock a collapsed viewport height from its init-time measurement.
      kiFlkty.on('ready', function () { kiFlkty.resize(); });
      kiInstances.push(kiFlkty);
    });
  }
  whenFlickity(initKeyIngredients);
  // Re-init after a Combined Listings no-reload section swap (theme.dev.js dispatches this).
  document.addEventListener('pdp:swapped', function () { whenFlickity(initKeyIngredients); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdpv2-upsell-prev], [data-pdpv2-upsell-next]');
    if (!btn) return;
    var scope = btn.closest('upsell-carousel') || btn.closest('.product__complementary');
    var carousel = scope && scope.querySelector('.products-carousel');
    if (!carousel || !window.themeVendor || !window.themeVendor.Flickity) return;
    var flkty = window.themeVendor.Flickity.data(carousel);
    if (!flkty) return;
    if (btn.hasAttribute('data-pdpv2-upsell-prev')) flkty.previous();
    else flkty.next();
  });

  // Show the prev arrow only once the carousel has moved off the first slide.
  function wireUpsellPrevArrow(cp) {
    var carousel = cp.querySelector('.products-carousel');
    if (!carousel || !window.themeVendor || !window.themeVendor.Flickity) return false;
    var flkty = window.themeVendor.Flickity.data(carousel);
    if (!flkty) return false;
    var wrap = carousel.closest('upsell-carousel');
    function sync() { if (wrap) wrap.classList.toggle('pdpv2-show-prev', flkty.selectedIndex !== 0); }
    flkty.on('select', sync);
    sync();
    return true;
  }

  document.querySelectorAll('complementary-products').forEach(function (cp) {
    if (wireUpsellPrevArrow(cp)) return;
    var obs = new MutationObserver(function () {
      if (wireUpsellPrevArrow(cp)) obs.disconnect();
    });
    obs.observe(cp, { childList: true, subtree: true });
  });
})();

